export function translateAuthError(error) {
  const msg = (error?.message || error || '').toLowerCase();
  if (msg.includes('already registered') || msg.includes('already exists'))
    return 'Cette adresse email est déjà utilisée. Connectez-vous ou réinitialisez votre mot de passe.';
  if (msg.includes('password') && msg.includes('characters'))
    return 'Le mot de passe doit contenir au moins 8 caractères.';
  if (msg.includes('invalid email'))
    return 'Adresse email invalide.';
  if (msg.includes('network') || msg.includes('failed to fetch'))
    return 'Impossible de se connecter au serveur. Vérifiez votre connexion.';
  if (msg.includes('rate limit'))
    return 'Trop de tentatives. Veuillez patienter quelques minutes.';
  if (msg.includes('weak password'))
    return 'Mot de passe trop faible. Utilisez au moins 8 caractères avec lettres et chiffres.';
  if (msg.includes('invalid login') || msg.includes('invalid credentials'))
    return 'Email ou mot de passe incorrect.';
  return 'Une erreur est survenue. Veuillez réessayer.';
}
